export enum ContactType {
  Ship = "shipContact",
  Bill = "billContact",
}
